import './App.css';
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Admin Components

import AdminPanelLayout from './Components/AdminPanelComponents/AdminPanelLayoutsComponents/AdminPanelLayout';
import UnauthorizedPage from './Components/AdminPanelComponents/LoginComponents/UnauthorizedPage';

// Auth Utils
import ProtectedRoute from './auth/ProtectedRoute';
import { checkTokenExpiration } from './auth/checkToken';
import LoginPage from './Components/AdminPanelComponents/LoginComponents/LoginPage';
import AdminFooter from './Components/AdminPanelComponents/FooterComponents/AdminFooter';
import ChangePassword from './Components/AdminPanelComponents/LoginComponents/ChangePassword';
import AdminDashboardPage from './Components/AdminPanelComponents/AdminPanelPages/AdminDashboardPage';
import CurrentAlumniPage from './Components/AdminPanelComponents/AdminPanelPages/CurrentAlumniPage';
import PendingAlumniPage from './Components/AdminPanelComponents/AdminPanelPages/PendingAlumniPage';
import RejectedPage from './Components/AdminPanelComponents/AdminPanelPages/RejectedPage';
import EditAlumniFormPage from './Components/AdminPanelComponents/AdminPanelPages/EditAlumniFormPage';
import ViewAlumniPage from './Components/AdminPanelComponents/AdminPanelPages/ViewAlumniPage';
import DeleteAlumniPage from './Components/AdminPanelComponents/AdminPanelPages/DeleteAlumniPage';
import DeletedAlumniPage from './Components/AdminPanelComponents/AdminPanelPages/DeletedAlumniPage';
import ManageAlumniPage from './Components/AdminPanelComponents/AdminPanelPages/ManageAlumniPage';
import JobsPage from './Components/AdminPanelComponents/AdminPanelPages/JobsPage';
import PostJobFormPage from './Components/AdminPanelComponents/AdminPanelPages/PostJobFormPage';
import EditJobFormPage from './Components/AdminPanelComponents/AdminPanelPages/EditJobFormPage';
import ViewJobPage from './Components/AdminPanelComponents/AdminPanelPages/ViewJobPage';
import ProjectsPage from './Components/AdminPanelComponents/AdminPanelPages/ProjectsPage';
import PostProjectFormPage from './Components/AdminPanelComponents/AdminPanelPages/PostProjectFormPage';
import AddProjectFundForm from './Components/AdminPanelComponents/AdminPanelPages/AddProjectFundForm';
import EditProjectFormPage from './Components/AdminPanelComponents/AdminPanelPages/EditProjectFormPage';
import ViewProjectPage from './Components/AdminPanelComponents/AdminPanelPages/ViewProjectPage';
import Eventage from './Components/AdminPanelComponents/AdminPanelPages/Eventage';
import NewsPage from './Components/AdminPanelComponents/AdminPanelPages/NewsPage';
import AddEventFormPage from './Components/AdminPanelComponents/AdminPanelPages/AddEventFormPage';
import AddNewsFormPage from './Components/AdminPanelComponents/AdminPanelPages/AddNewsFormPage';
import GalleryPage from './Components/AdminPanelComponents/AdminPanelPages/GalleryPage';
import AddGalleryPage from './Components/AdminPanelComponents/AdminPanelPages/AddGalleryPage';
import LoginHistoryPage from './Components/AdminPanelComponents/AdminPanelPages/LoginHistoryPage';
import TalentPoolPage from './Components/AdminPanelComponents/AdminPanelPages/TalentPoolPage';
import PendingTalentPage from './Components/AdminPanelComponents/AdminPanelPages/PendingTalentPage';
import CurrentTalentPoolPage from './Components/AdminPanelComponents/AdminPanelPages/CurrentTalentPoolPage';
import RejectedTalentPage from './Components/AdminPanelComponents/AdminPanelPages/RejectedTalentPage';
import UsersPage from './Components/AdminPanelComponents/AdminPanelPages/UsersPage';
import UserSelectionPage from './Components/AdminPanelComponents/AdminPanelPages/UserSelectionPage';
import ViewTalentPage from './Components/AdminPanelComponents/AdminPanelPages/ViewTalentPage';
import AnnouncementPage from './Components/AdminPanelComponents/AdminPanelPages/AnnouncementPage';


function App() {
  // Automatically check token expiration on load and every 1 minute
  useEffect(() => {
    checkTokenExpiration(); // initial check
    const interval = setInterval(checkTokenExpiration, 60_000); // every 1 minute
    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Login & Unauthorized */}
        <Route path="/" element={<LoginPage />} />
        <Route path="unauthorize" element={<UnauthorizedPage />} />

        {/* Admin Panel Protected Routes */}
        <Route element={<ProtectedRoute allowedRoles={["ADMIN", "SYSTEM ADMIN"]} />}>
          <Route path="/admin-panel" element={<AdminPanelLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboardPage />} />
              <Route path="current-members" element={<CurrentAlumniPage/>} />
              <Route path="pending-registrations" element={<PendingAlumniPage/>} />
              <Route path="rejected-registrations" element={<RejectedPage/>} />
              <Route path="alumni/edit/:id" element={<EditAlumniFormPage/>} />
              <Route path="alumni/view/:id" element={<ViewAlumniPage/>} />
              <Route path="alumni/delete/:id" element={<DeleteAlumniPage/>} />
              <Route path="deleted-alumni" element={<DeletedAlumniPage/>} />
              <Route path="manage-alumni" element={<ManageAlumniPage/>} />
              <Route path="jobs-page" element={<JobsPage/>} />
              <Route path="jobs/post-job" element={<PostJobFormPage/>} />
              <Route path="jobs/edit/:jobId" element={<EditJobFormPage/>} />
              <Route path="jobs/view/:jobId" element={<ViewJobPage/>} />
              <Route path="projects-page" element={<ProjectsPage/>} />
              <Route path="projects/post-project" element={<PostProjectFormPage/>} />
              <Route path="projects/add-fund/:id" element={<AddProjectFundForm/>} />
              <Route path="projects/edit/:id" element={<EditProjectFormPage/>} />
              <Route path="projects/view/:id" element={<ViewProjectPage/>} />
              <Route path="logs" element={<LoginHistoryPage/>} />

              <Route path="events-page" element={<Eventage/>} />
              <Route path="events/add" element={<AddEventFormPage/>} />
              <Route path="news-page" element={<NewsPage/>} />
              <Route path="news/add" element={<AddNewsFormPage/>} />
              <Route path="gallery-page" element={<GalleryPage/>} />
              <Route path="gallery/add-event" element={<AddGalleryPage/>} />

              <Route path="talent-pool" element={<TalentPoolPage/>} />
              <Route path="pending-talents" element={<PendingTalentPage/>} />
              <Route path="approved-talents" element={<CurrentTalentPoolPage/>} />
              <Route path="rejected-talents" element={<RejectedTalentPage/>} />
              <Route path="talent/view/:id" element={<ViewTalentPage/>} />

              <Route path="announcement-page" element={<AnnouncementPage/>} />



              <Route path="users" element={<UsersPage/>}/>
              <Route path="add-user" element={<UserSelectionPage/>}/>
              <Route path="change-password" element={<ChangePassword />}/>


              


            
            
          </Route>
        </Route>


        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <AdminFooter/>
    </Router>
  );
}

export default App;
